import type { I2VModelId } from "@saas/image-to-video/types";
import { getI2VModel } from "@saas/image-to-video/types";

/**
 * 首页 hero 下拉和落地页里用真实模型名，不用 Fast / Quality / Master 这套档位名。
 * 2026-10-02 老公拍板：每个模型都要做落地页，标题写 Seedance、下拉却叫
 * Master 3.0 会让用户怀疑挂羊头卖狗肉。只改营销页展示，`label` 字段在
 * types.ts 里还被拿来按档位分组（同一 label 下按输入范式找 id），所以不动它。
 * 2026-10-06 起 /image-to-video 下拉和各处历史卡片也改用这里的名字。
 * Evolink 的 Basic 没有对外的公开名，保持原样。
 *
 * 单独成文件是因为服务端组件（如 /start-end-frame-video 的模型对照表）也要用，
 * 放在 "use client" 的 VideoGeneratorHero 里服务端调不到。
 */
const MODEL_DISPLAY_NAMES: Partial<Record<I2VModelId, string>> = {
	"basic-between": "Seedance 2.0 Mini",
	"fast-2.0": "Veo 3.1 Lite",
	"veo-3.1-fast": "Veo 3.1 Fast",
	"veo-3.1-quality": "Veo 3.1 Quality",
	"fast-3.0": "Grok Imagine 1.5",
	"quality-2.0": "MiniMax H3",
	"quality-2.0-ref": "MiniMax H3",
	"quality-2.0-text": "MiniMax H3",
	"wan-3.0": "Wan 3.0",
	"wan-3.0-prime": "Wan 3.0 Prime",
	"quality-3.0": "Gemini Omni Flash",
	"master-2.0": "Kling 3.0",
	"master-2.0-ref": "Kling 3.0",
	"master-2.0-text": "Kling 3.0",
	"kling-4.0": "Kling 4.0",
	"kling-4.0-ref": "Kling 4.0",
	"kling-2.6-motion": "Kling 2.6 Motion Control",
	"omnihuman-2": "OmniHuman 2.0",
	"master-3.0": "Seedance 2.0",
	"seedance-2-mini": "Seedance 2.0 Mini",
	"seedance-2-fast": "Seedance 2.0 Fast",
	"seedance-2": "Seedance 2.0",
	"seedance-2.5": "Seedance 2.5",
};

export function getModelDisplayName(id: I2VModelId): string {
	return MODEL_DISPLAY_NAMES[id] ?? getI2VModel(id).label;
}
